import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

import { Card, CardContent, CardHeader, CardTitle } from '@/components/v2/ui'
import { useListingAuditStatus } from '@/hooks/useListingBuilder'

interface ListingBuilderProgressProps {
  jobId: string
  onComplete: () => void
  onFailed: () => void
}

/** Live-Fortschritt des laufenden Audits (Polling alle 3s). */
export function ListingBuilderProgress({ jobId, onComplete, onFailed }: ListingBuilderProgressProps) {
  const { t } = useTranslation()
  const { data, isError } = useListingAuditStatus(jobId)

  useEffect(() => {
    if (data?.status === 'completed') onComplete()
    if (data?.status === 'failed' || isError) onFailed()
  }, [data?.status, isError, onComplete, onFailed])

  const pct = data?.progress?.percentage ?? 0

  return (
    <Card className="listing-builder-progress">
      <CardHeader>
        <CardTitle>{t('listingBuilder.progressTitle')}</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="listing-builder-progress-status flex flex-col gap-3" aria-live="polite" aria-busy="true">
          <p className="text-sm text-muted-foreground">
            {data?.current_step ?? t('listingBuilder.queued')} — {pct}%
          </p>
          <div className="h-2 w-full overflow-hidden rounded-full bg-muted" role="progressbar"
            aria-valuenow={Math.round(pct)} aria-valuemin={0} aria-valuemax={100}>
            <div className="h-full bg-primary transition-all" style={{ width: `${pct}%` }} />
          </div>
        </div>
      </CardContent>
    </Card>
  )
}
